import React from 'react';
import ModalDialog from '../components/Dialog/ModalDialog';
import Typography from '../components/Text/Typography';
import './TermsDialog.css';

interface TermsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsDialog: React.FC<TermsDialogProps> = ({ isOpen, onClose }) => {
  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      title="Terms & Conditions"
      primaryButton={{
        label: "Close",
        onClick: onClose
      }}
      maxWidth="600px"
      maxHeight="500px"
    >
      <div className="terms-dialog">
        <div className="terms-dialog__content">
          <Typography variant="body">
          <strong>📜 Dew – Terms & Conditions</strong>
          <br /><br />
          
          <strong>Effective Date: September 16, 2025</strong>
          <br /><br />
          
          Welcome to Dew. These Terms & Conditions ("Terms") govern your access and use of Dew's website, app, and related services ("Services"). By creating an account or using Dew, you agree to these Terms.
          <br /><br />
          
          <strong>1. Eligibility</strong>
          <br />
          You must be at least 18 years old, or have parental/guardian consent if younger.
          <br />
          By using Dew, you confirm you meet these requirements.
          <br /><br />
          
          <strong>2. Services Provided</strong>
          <br />
          Dew allows users to organize skincare products into routines and customize routines.
          <br />
          Dew also provides an Update Routine feature that suggests changes using our algorithm.
          <br />
          Dew does not sell products and does not provide medical advice.
          <br /><br />
          
          <strong>3. Health Disclaimer</strong>
          <br />
          Dew is for personal wellness and organizational purposes only.
          <br />
          Information provided by Dew is not medical advice. Always consult a licensed dermatologist or healthcare provider before making decisions about your skin health.
          <br />
          Dew is not responsible for adverse reactions or results from using any products.
          <br /><br />
          
          <strong>4. User Accounts</strong>
          <br />
          You are responsible for maintaining the confidentiality of your login credentials.
          <br />
          You agree to provide accurate information (e.g., skin type, concerns, allergies) to improve your experience.
          <br />
          Dew may suspend or terminate accounts for misuse, including providing false information or violating these Terms.
          <br /><br />
          
          <strong>5. User Content</strong>
          <br />
          You may create routines, add personal notes, or share feedback ("User Content").
          <br />
          By submitting User Content, you grant Dew a non-exclusive, worldwide, royalty-free license to use it for operating and improving the Services.
          <br />
          You remain the owner of your User Content.
          <br /><br />
          
          <strong>6. Privacy</strong>
          <br />
          Your use of Dew is also governed by our Privacy Policy.
          <br /><br />
          
          <strong>7. Limitation of Liability</strong>
          <br />
          Dew is provided "as is" without warranties.
          <br />
          Dew is not liable for damages resulting from reliance on the platform, including product use or skin reactions.
          <br /><br />
          
          <strong>8. Changes to Terms</strong>
          <br />
          Dew may update these Terms from time to time.
          <br />
          Continued use after updates means you accept the new Terms.
          <br /><br />
          
          <strong>9. Governing Law</strong>
          <br />
          These Terms are governed by the laws of the United States.
          </Typography>
        </div>
      </div>
    </ModalDialog>
  );
};

export default TermsDialog;
